import React, {useContext} from "react";
import { AuthContext } from '../context/AuthContext';
import { useNavigate, useLocation } from "react-router-dom";
import logo from '../image/logo.png';
import "./Logo.css";

const Logo = () => {
   const { userid } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  
  const isLoginPage = location.pathname === "/";

  const handleClick = () => {
    if (!isLoginPage || userid) {
      navigate("/home"); // Change the route as needed
    }
  };

  return (
    <div 
      className="logo-container" 
      onClick={handleClick} 
      style={{ cursor: isLoginPage || !userid ? "default" : "pointer" }}
    >
      <img src={logo} alt="Logo" className="p-login-logo" />
      <p className="p-logo-text">Digital <span>Knowledge</span> Platform</p>
    </div>
  );
};

export default Logo;
